/* Rorilio · PDP Plantillas : minuteur (minuit America/Mexico_City, redémarre chaque jour), galerie, couleur/taille, packs 1/3/5 avec couleur et taille
   par paire (lignes réelles par variante ; codes de palier et cadeaux posés par le moteur rorilio-offers.js), FAQ, guide des tailles, vidéos,
   témoignages, avant/après, stats animées, vidéo mécanisme. */
(function () {
  if (window.__pltPdp) return; window.__pltPdp = true;
  function $a(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function two(n) { return (n < 10 ? '0' : '') + n; }
  function tzNow(tz) {
    try {
      var p = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date());
      var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
      return { date: o.year + '-' + o.month + '-' + o.day, secs: (parseInt(o.hour, 10) % 24) * 3600 + parseInt(o.minute, 10) * 60 + parseInt(o.second, 10) };
    } catch (e) { var d = new Date(); return { date: d.toISOString().slice(0, 10), secs: d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds() }; }
  }
  ready(function () {
    /* Minuteurs */
    var timers = $a('[data-plt-timer]');
    function tick() {
      timers.forEach(function (el) {
        var n = tzNow(el.getAttribute('data-tz') || 'America/Mexico_City'), until = el.getAttribute('data-until') || '';
        if (until && n.date > until) { el.style.display = 'none'; return; }
        var rest = 86400 - n.secs; if (rest >= 86400) rest = 0;
        var q = function (s) { return el.querySelector(s); };
        if (q('[data-d]')) q('[data-d]').textContent = '00';
        q('[data-h]').textContent = two(Math.floor(rest / 3600)); q('[data-m]').textContent = two(Math.floor(rest / 60) % 60); q('[data-s]').textContent = two(rest % 60);
      });
    }
    if (timers.length) { tick(); setInterval(tick, 1000); }

    /* Galerie */
    var galApi = null;
    $a('[data-plt-gal]').forEach(function (g) {
      var sl = g.querySelector('.plt-gal__slides'), th = $a('.plt-gal__thumb', g), slides = $a('.plt-gal__slide', g), cur = 0;
      function mark(i) { cur = i; th.forEach(function (t, k) { t.classList.toggle('is-on', k === i); }); }
      function go(i, inst) { i = (i + slides.length) % slides.length; sl.scrollTo({ left: sl.clientWidth * i, behavior: inst ? 'auto' : 'smooth' }); mark(i); }
      th.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      $a('.plt-gal__nav', g).forEach(function (b) { b.addEventListener('click', function () { go(cur + parseInt(b.getAttribute('data-dir'), 10)); }); });
      var w; sl.addEventListener('scroll', function () { clearTimeout(w); w = setTimeout(function () { mark(Math.round(sl.scrollLeft / (sl.clientWidth || 1))); }, 80); }, { passive: true });
      galApi = { toMedia: function (id) { slides.forEach(function (s, i) { if (String(s.getAttribute('data-media')) === String(id)) go(i, true); }); } };
    });

    /* Achat */
    $a('[data-plt-buy]').forEach(function (b) {
      var V = JSON.parse(b.querySelector('[data-plt-variants]').textContent || '[]');
      var sw = {}; (b.getAttribute('data-swatches') || '').split(',').forEach(function (x) { var k = x.split(':'); if (k[1]) sw[k[0].trim()] = k[1].trim(); });
      $a('.plt-sw__b', b).forEach(function (x) { var c = sw[x.getAttribute('data-plt-color')]; if (c) x.firstChild.style.background = c; });
      var color = (b.querySelector('.plt-sw__b.is-on') || {}).getAttribute ? b.querySelector('.plt-sw__b.is-on').getAttribute('data-plt-color') : V[0].o1;
      var size = b.querySelector('.plt-sz__b.is-on') ? b.querySelector('.plt-sz__b.is-on').getAttribute('data-plt-size') : V[0].o2;
      function find(c, s) { for (var i = 0; i < V.length; i++) if (V[i].o1 === c && V[i].o2 === s) return V[i]; return null; }
      function imgOf(c) { for (var i = 0; i < V.length; i++) if (V[i].o1 === c) return V[i]; return null; }
      var packs = $a('[data-pack]', b), sel = b.querySelector('[data-pack].is-on') || packs[0];
      var savedEl = b.querySelector('[data-plt-saved]'), atc = b.querySelector('[data-atc]'), err = b.querySelector('[data-err]');
      function paintPair(row) { var v = imgOf(row.querySelector('[data-pair-color]').value), im = row.querySelector('[data-pair-img]'); if (v && v.img && im) im.src = v.img; }
      function syncAll() {
        $a('[data-pair]', b).forEach(function (row) { row.querySelector('[data-pair-color]').value = color; row.querySelector('[data-pair-size]').value = size; paintPair(row); });
        $a('.plt-sw__b', b).forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-plt-color') === color); });
        $a('.plt-sz__b', b).forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-plt-size') === size); });
        var cn = b.querySelector('[data-plt-color-name]'), sn = b.querySelector('[data-plt-size-name]');
        if (cn) cn.textContent = color; if (sn) sn.textContent = size.split(' (')[0];
      }
      $a('.plt-sw__b', b).forEach(function (x) { x.addEventListener('click', function () { color = x.getAttribute('data-plt-color'); syncAll(); var v = find(color, size); if (v && galApi) galApi.toMedia(v.media); }); });
      $a('.plt-sz__b', b).forEach(function (x) { x.addEventListener('click', function () { size = x.getAttribute('data-plt-size'); syncAll(); }); });
      $a('[data-pair]', b).forEach(function (row) {
        row.addEventListener('click', function (e) { e.stopPropagation(); });
        row.querySelector('[data-pair-color]').addEventListener('change', function () { paintPair(row); });
      });
      function paint() {
        packs.forEach(function (p) { var on = p === sel; p.classList.toggle('is-on', on); p.setAttribute('aria-checked', on ? 'true' : 'false'); });
        if (savedEl) { var s = sel.getAttribute('data-saved'); savedEl.textContent = savedEl.getAttribute('data-tpl').replace('[monto]', s); savedEl.hidden = !s || /^\D*0$/.test(s); }
      }
      packs.forEach(function (p) {
        p.addEventListener('click', function () { if (sel !== p) { sel = p; paint(); } });
        p.addEventListener('keydown', function (e) { if (e.target === p && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); sel = p; paint(); } });
      });
      function items() {
        var q = parseInt(sel.getAttribute('data-qty'), 10) || 1, map = {}, rows = $a('[data-pair]', sel);
        if (rows.length) rows.forEach(function (r) { var v = find(r.querySelector('[data-pair-color]').value, r.querySelector('[data-pair-size]').value); if (v) map[v.id] = (map[v.id] || 0) + 1; });
        else { var v = find(color, size); if (v) map[v.id] = q; }
        return Object.keys(map).map(function (id) { return { id: Number(id), quantity: map[id] }; });
      }
      function fail(e) { atc.classList.remove('is-busy'); if (err) { err.textContent = (e && e.message) || 'Error'; err.hidden = false; } }
      if (atc) atc.addEventListener('click', function () {
        var its = items(); if (!its.length) return fail(new Error('Selecciona color y talla'));
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/', RO = window.RorilioOffers;
        atc.classList.add('is-busy'); if (err) err.hidden = true;
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: its }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Error'); return j; }); })
          .then(function () { return RO ? RO.reconcile(true) : null; })
          .then(function (st) {
            atc.classList.remove('is-busy');
            if (st) delete st._silent;
            if (!RO || !st || !st.sections || !RO.open(st)) location.href = root + 'cart';
          })
          .catch(fail);
      });
      syncAll(); paint();
    });

    /* FAQ */
    $a('[data-plt-acc]').forEach(function (list) {
      list.addEventListener('click', function (e) {
        var q = e.target.closest('[data-q]'); if (!q || !list.contains(q)) return;
        var it = q.parentElement, open = it.classList.contains('is-open');
        it.classList.toggle('is-open', !open); q.setAttribute('aria-expanded', open ? 'false' : 'true');
        var a = it.querySelector('[data-a]'); if (a) a.hidden = open;
      });
    });
    /* Guide des tailles */
    $a('[data-plt-open]').forEach(function (b) {
      var m = document.getElementById(b.getAttribute('data-plt-open')); if (!m) return;
      if (m.parentNode !== document.body) document.body.appendChild(m);
      b.addEventListener('click', function () { m.hidden = false; });
      m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('[data-plt-close]')) m.hidden = true; });
    });
    /* Vidéos clients */
    var vids = $a('[data-plt-vid]');
    vids.forEach(function (box) {
      var v = box.querySelector('video');
      box.querySelector('.plt-vid__play').addEventListener('click', function () {
        vids.forEach(function (o) { if (o !== box) { o.querySelector('video').pause(); o.classList.remove('is-playing'); o.querySelector('video').controls = false; } });
        box.classList.add('is-playing'); v.controls = true; v.play();
      });
      v.addEventListener('ended', function () { box.classList.remove('is-playing'); v.controls = false; });
    });
    $a('[data-plt-vids]').forEach(function (sc) {
      var bar = sc.parentNode.querySelector('[data-plt-prog]'); if (!bar) return;
      function upd() { var max = sc.scrollWidth - sc.clientWidth, r = max > 0 ? sc.scrollLeft / max : 0, w = sc.clientWidth / (sc.scrollWidth || 1); bar.style.width = Math.max(w * 100, 20) + '%'; bar.style.transform = 'translateX(' + (r * (100 / Math.max(w, .2) - 100)) + '%)'; }
      sc.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    });
    /* Témoignages */
    $a('[data-plt-tst]').forEach(function (s) {
      var tr = s.querySelector('.plt-tst__tr'), cards = $a('.plt-tc', tr), cur = 0, cnt = s.querySelector('[data-cnt]');
      var prev = s.querySelector('[data-dir="-1"]'), next = s.querySelector('[data-dir="1"]');
      function step() { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : tr.clientWidth; }
      function vis() { return Math.max(1, Math.round(tr.parentNode.clientWidth / step())); }
      function go(i) { var m = Math.max(0, cards.length - vis()); cur = Math.min(Math.max(i, 0), m); tr.style.transform = 'translateX(' + (-cur * step()) + 'px)'; prev.disabled = cur === 0; next.disabled = cur >= m; if (cnt) cnt.textContent = two(cur + 1) + ' / ' + two(cards.length); }
      prev.addEventListener('click', function () { go(cur - 1); }); next.addEventListener('click', function () { go(cur + 1); });
      var sx = 0; tr.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      tr.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); }, { passive: true });
      window.addEventListener('resize', function () { go(cur); }); go(0);
    });
    /* Avant / après */
    $a('[data-plt-ba]').forEach(function (s) {
      var top = s.querySelector('.plt-ba__top'), h = s.querySelector('.plt-ba__h'), inp = s.querySelector('.plt-ba__in');
      function set(v) { top.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)'; h.style.left = v + '%'; }
      inp.addEventListener('input', function () { set(inp.value); }); set(inp.value);
    });
    /* Stats animées */
    var nums = $a('[data-plt-count]');
    if (nums.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) {
        if (!e.isIntersecting) return; io.unobserve(e.target);
        var el = e.target, to = parseInt(el.getAttribute('data-plt-count'), 10), t0 = null;
        function f(ts) { if (!t0) t0 = ts; var k = Math.min((ts - t0) / 1400, 1); el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(f); }
        requestAnimationFrame(f);
      }); }, { threshold: .4 });
      nums.forEach(function (n) { n.textContent = '0'; io.observe(n); });
    }
    /* Vidéo mécanisme : lecture/pause */
    $a('[data-plt-mech]').forEach(function (box) {
      var v = box.querySelector('video'), b = box.querySelector('.plt-mech__pp');
      if (b) b.addEventListener('click', function () { if (v.paused) { v.play(); b.textContent = '❚❚'; } else { v.pause(); b.textContent = '▶'; } });
    });
  });
})();
